import { GroupType, OptionType } from '../../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { OwnerModelDTO, OwnerOptionsDTO } from '../../../OtherAssets.meta';

interface Params {
  options: OwnerOptionsDTO;
}

export const useAssetOwnership = ({ options }: Params) => {
  return {
    ownerOptions: Object.keys(options).map(key => ({
      label: key,
      options: (options[key] || []).map((owner, ind) => ({
        value: owner.Id,
        label: owner.Name,
      })),
    })) as GroupType<OptionType<string>>[],
    allOptions: Object.keys(options)
      .map(key => options[key])
      .flat() as OwnerModelDTO[],
  };
};
